import React from 'react';
import styled from 'styled-components';
import { MainHeading, SubHeading, BodyText, TextCenter } from '../styles/GlobalStyles';
import LaLigaLogo from './LaLigaLogo';

const HeroContainer = styled(TextCenter).attrs({
  className: 'hero-container'
})`
  padding: 0;
  position: relative;
  z-index: 10;

  @media (max-width: 1024px) {
    padding: 40px 10px;
  }
`;

const SubtitleWithLogo = styled(BodyText).attrs({
  className: 'subtitle-with-logo'
})`
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  gap: 15px;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const HeroSection: React.FC = () => {
  return (
    <HeroContainer>
      <SubHeading>NORMAL QUE ESTÉS</SubHeading>
      <MainHeading style={{ 
        fontFamily: "'CocomatPro-Black', 'CocomatPro', 'Arial Black', sans-serif",
        fontWeight: 900,
        fontStretch: 'ultra-condensed'
      }}>HIPEREMOCIONADO</MainHeading>
      <SubtitleWithLogo>
        <div>PORQUE TE TRAEMOS <strong>TODA</strong>{' '}</div>
        <LaLigaLogo />
      </SubtitleWithLogo>
    </HeroContainer>
  );
};

export default HeroSection;